import useAccountBasicInfo from 'lib/hooks/api/useAccountBasicInfo'
import { useAuthContext } from 'components/Auth/AuthContextProvider'

import { ProfileProps } from './Profile'

type UseProfileProps = (
  enabled?: boolean
) => ProfileProps & { isLoading: boolean }

const useProfileProps: UseProfileProps = enabled => {
  const { user } = useAuthContext()
  const { data } = useAccountBasicInfo(enabled)

  return {
    isLoading: user == null || data == null,
    isStudent: user?.isIWStudent === true,
    name: data?.FirstName ?? '',
    imageUrl: data?.ImageURL ?? '',
  }
}

export default useProfileProps
